import { CampaignFormData, AdgroupFormData, InventoryFlow, AdgroupConfig } from '@tt4b/ttam-enums';
import { useStdAdgroupIs } from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';

export function useSwitchPropsDisabled(props: { adgroupConfig: Ref<AdgroupConfig> }) {
  const { adgroupConfig } = props;

  return {
    disabled: computed(() => adgroupConfig.value?.disableComment),
  };
}

export function useSwitchPropsVisible(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { hasInventoryFlow } = useStdAdgroupIs({
    campaignFormData: props.campaignData,
    adgroupFormData: props.adgroupData,
  });

  const visible = computed(() => hasInventoryFlow(InventoryFlow.TIKTOK) || hasInventoryFlow(InventoryFlow.HELO));
  return {
    visible,
  };
}
